<template>
	<div class="model" ref="model">
		<div class="paddM">
			<div v-show="load" :class="['loading',loading_in?'loading-in':'']">
					
					<img class="loading_img" src="../assets/loadings.gif">
			</div>  
			<div class="paddmm" v-show="!load">
				
				<div id="container" ></div>
				<div class="top">
					<div class="left">
						<svg @click="goLastPage" t="1647656256556" class="leftSvg icon" viewBox="0 0 1024 1024"
							version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11856" width="24px" height="24px">
							<path
								d="M305.519192 557.640404c-11.636364 0-23.40202-4.39596-32.323232-13.317172-17.842424-17.842424-17.842424-46.674747 0-64.517171L683.830303 69.30101c17.842424-17.842424 46.674747-17.842424 64.517172 0 17.842424 17.842424 17.842424 46.674747 0 64.517172L337.713131 544.323232c-8.921212 8.921212-20.557576 13.317172-32.193939 13.317172z m0 0"
								fill="#ffffff" p-id="11857"></path>
							<path
								d="M715.894949 968.145455c-11.636364 0-23.40202-4.39596-32.323232-13.317172L273.19596 544.323232c-17.842424-17.842424-17.842424-46.674747 0-64.517171 17.842424-17.842424 46.674747-17.842424 64.517171 0l410.505051 410.50505c17.842424 17.842424 17.842424 46.674747 0 64.517172-8.921212 8.921212-20.557576 13.317172-32.323233 13.317172z m0 0"
								fill="#ffffff" p-id="11858"></path>
						</svg>
						长城文创珍宝中心
					</div>
					<div class="right">
						<img src="../assets/ccwclogo.png" alt="">
					</div>

				</div>
				<div class="vr_btns">
					<div class="" v-show="!VR" @click="changeVr">
						<img src="../assets/vr_btn.png" alt="">
						进入VR
					</div>
					<div class="" v-show="VR" @click="changeVr">
						<img src="../assets/back_btn.png" alt="">
						退出VR
					</div>
				</div>
				<div class="bottom">

					<div class="name">{{ info.name }}</div>
					<div >由 广东网录 提供技术支持</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import {
	getArtProduct,
	getProduct,
	verifyPassword,
	getMiniAppUrl
} from "@/api/api.js"
// import {THREE} from "../utils/newThree.js";
import * as THREE from "three";
import {
	OrbitControls
} from "three/examples/jsm/controls/OrbitControls.js";

import {
	FBXLoader
} from 'three/examples/jsm/loaders/FBXLoader.js';
import {
	DRACOLoader
} from "three/examples/jsm/loaders/DRACOLoader.js";
import {
	OBJLoader	
} from "three/examples/jsm/loaders/OBJLoader";
import { StereoEffect } from "three/examples/jsm/effects/StereoEffect"


import bg from "../assets/bj.png"
import hbg from "../assets/hbg.jpg"

export default {
	data() {
		return {
			load: true,
			introduce_show: false,
			loading_in: false,
			width: 0,
			height: 0,
			percentage: 10,
			model: [],
			color: "",
			textp: [],
			HDpic: [],
			SPHpic: [],
			sph: [],
			falg1: 0,
			falg2: 0,
			flag: 0,
			url: 'test.jpg',
			more: false,
			isNormal: true,
			modealList: [],
			picrouter: 'http://192.168.1.150:83/',
			loadPic: '/pic',
			input: '',
			dialogVisible: false,
			loadHDD: false,
			loadSHDD: false,
			info: {
				name: '',
				user: {
					avatar: "test.jpg",
				},
			},
			hasSHD: false,
			VR:false
		};
	},
	async mounted() {
		// this.initPolyfill()
		this.time = new Date().getTime()
		if (window.innerWidth > 750) {
			this.introduce_show = true
		}
		// this.loading_in=true
		// let body = document.body
		// body.style.background = "transparent"
		this.height = window.innerHeight * 0.6;
		this.id = this.$route.params.id;
		const res = await getProduct(this.id);
		
		const work = res.data
		this.info = work
		this.url = work.url.indexOf('http') == -1 ? this.picrouter + work.url : work.url;
		
		for (let i = 0; i < work.model.length; i++) {
			if (work.model[i].three.indexOf('http') == -1) {
				work.model[i].three = this.loadPic + work.model[i].three
			}
		}
		this.model = work.model;
		this.Light = work.Light
		this.pic = work.npic ? work.npic : work.pic
		for (let i = 0; i < this.pic.length; i++) {
			if (this.pic[i].indexOf('http') == -1) {
				this.pic[i] = this.loadPic + this.pic[i]
			}
			if (work.pic[i].indexOf('http') == -1) {
				work.pic[i] = this.loadPic + work.pic[i]
			}
		}
		// getArtProduct(this.info.artist_id).then(res => {

		// 	this.modealList = res.data
		// })
		this.hdp = work.pic
		this.sph = work.hpic || []
		this.env = work.env.indexOf('http') == -1 ? this.loadPic + work.env : work.env
		this.scene = new THREE.Scene();
		this.controls;
		this.clock = null;
		this.renderer = null;
		this.camera = null;
		this.mixer = null;
		this.anid = null;
		this.meshList = []
		this.glbLoader = null;
		this.objLoader = null;
		
		this.init();
	},
	beforeDestroy() {
		this.scene = null;
		this.controls.dispose();
		this.clock = null;
		this.renderer.dispose();
		this.camera = null;
		this.mixer = null;
		cancelAnimationFrame(this.anid);
		THREE.Cache.clear()
	},
	methods: {
		async init() {
			// this.clock = new THREE.Clock();
			this.width = window.innerWidth > 750 ? window.innerWidth - 540 : window.innerWidth;
			this.height = window.innerWidth > 750 ? window.innerHeight : window.innerHeight;
			const container = document.getElementById("container");
			this.renderer = new THREE.WebGLRenderer({
				antialias: true,
				alpha: true
			}); //渲染器
			this.renderer.setClearAlpha(0);
			this.renderer.setPixelRatio(window.devicePixelRatio); //设置像素
			this.renderer.setSize(this.width, this.height); //设置大小
			this.renderer.outputEncoding = THREE.sRGBEncoding;
			container.appendChild(this.renderer.domElement);
			
			// 场景
			let bg_teture = null
			await new THREE.TextureLoader().load(bg, (texture) => {

				this.scene.background = texture
				bg_teture = texture
				
			})
			let h_bg_teture = null
			await new THREE.TextureLoader().load(hbg, (texture) => {

				
				h_bg_teture = texture

			})
			// this.scene.background = new THREE.Color('transparent'); // 场景背景

			this.camera = new THREE.PerspectiveCamera(
				40,
				this.width / this.height,
				1,
				100
			); // 设置相机
			this.camera.position.set(0, 0, 20); // 相机位置

			this.controls = new OrbitControls(this.camera, this.renderer.domElement); // 轨道控制器
			this.controls.minDistance = 2
			this.controls.maxDistance = 60
			this.controls.target.set(0, 0.5, 0); // 设置控制器焦点
			this.controls.update(); // 更新控制器
			this.controls.enablePan = true; // 右键 双指移动 控制器焦点
			this.controls.enableDamping = true;

			this.scene.add(new THREE.HemisphereLight(0xffffff, 0xffffff, 0.8)); // 场景添加半球光 （天空 地面  光照强度） 灯光

			// const dirLight = new THREE.PointLight( 0xffffff, 0.4 ,200); // 设置平行光 灯光 （颜色 强度）
			// dirLight.position.set(0, 100, 0); //设置平行光位置
			// this.scene.add(dirLight); // 添加灯光

			// const dirLight1 = dirLight.clone()
			// dirLight1.position.set(0, 50, 50);
			// this.scene.add(dirLight1); 

			// const dirLight2 = dirLight.clone()
			// dirLight2.position.set(50, 0, -50);
			// this.scene.add(dirLight2); 

			// const dirLight3 = dirLight.clone()
			// dirLight3.position.set(-50, 0, -50);
			// this.scene.add(dirLight3); 

			// const dirLight4 = dirLight.clone()
			// dirLight4.position.set(0, -100, 0);
			// this.scene.add(dirLight4); 

			// const dirLight5 = dirLight.clone()
			// dirLight5.position.set(0, 0, 100);
			// this.scene.add(dirLight5); 


			// const dirLight3 = dirLight.clone()
			// dirLight3.position.set(0, -100, 0);
			// this.scene.add(dirLight3); 


			// const dirLight4 = dirLight.clone()
			// dirLight4.position.set(50, 0, 0);
			// this.scene.add(dirLight4); 

			// const dirLight5 = dirLight.clone()
			// dirLight5.position.set(-50, 0, 0);
			// this.scene.add(dirLight5);

			


			const dracoLoader = new DRACOLoader(); // 设置draco加载器 加载压缩后的gltf
			dracoLoader.setDecoderPath("/draco/"); // 设置路径  必须在public里

			let loader = null

			loader = dracoLoader;

			this.objLoader = new OBJLoader();



			for (let j = 0; j < this.model.length; j++) {
				this.meshList.push("")
			}
			for (let j = 0; j < this.pic.length; j++) {
				this.textp.push("")
				this.HDpic.push("")
			}
			for (let j = 0; j < this.sph.length; j++) {
				this.SPHpic.push("")
			}
			
			this.animate();
			
			new THREE.TextureLoader().load(this.env, (envMap) => {
				
				const pmremGenerator = new THREE.PMREMGenerator(this.renderer);
				pmremGenerator.compileEquirectangularShader();
				const exrCubeRenderTarget = pmremGenerator.fromEquirectangular(envMap)
				this.emap = exrCubeRenderTarget.texture
				this.emap.wrapS = THREE.ClampToEdgeWrapping;
				this.emap.wrapT = THREE.ClampToEdgeWrapping;
				for (let i = 0; i < this.pic.length; i++) {

					this.PicLoad(i, loader);
					


				}
			}, undefined, (err) => {
				console.log(err)
			});
			// for (let i = 0; i < this.pic.length; i++) {

			// 	this.PicLoad(i, loader);
			// 	// this.animate()
			console.log(888)
			window.addEventListener("orientationchange", ()=>{              
				setTimeout(()=>{
				this.width = window.innerWidth;
				this.height =  window.innerHeight;
				if (window.orientation == 180 || window.orientation == 0) {
					if(this.scene.background == bg_teture){

					}else{
						this.scene.background = bg_teture
					}
					
				} 
				if (window.orientation == 90 || window.orientation == -90 ){
					if(this.scene.background == h_bg_teture){

					}else{
						this.scene.background = h_bg_teture
					}
					
				} 
				this.camera.aspect = this.width / this.height;
				this.camera.updateProjectionMatrix();
				this.renderer.setSize(this.width, this.height);
				},100)
			}, false);
		
		},
		
		animate() {
			

			//   const delta = this.clock.getDelta();

			//   this.mixer.update(delta);
			if(this.VR){
				// this.controls.update();
				// // this.controlsVR.update()
				// this.renderer.clear()
				// let orbitPos = this.camera.position.clone();
				// let rotatedPosition = this.cameraVR.position.applyQuaternion(this.camera.quaternion);
				// this.camera.position.add(rotatedPosition);
				// this.camera.quaternion.multiply(this.cameraVR.quaternion);
				// this.camera.position.copy(orbitPos);
				
				// // this.renderer.outputEncoding = null
				// // this.effect.render(this.scene,this.cameraVR)
				// // 
				// this.renderer.autoClear = false
				// this.renderer.clear()
				// this.effect.render(this.sceneVR,this.cameraVR)
				// this.effect.render(this.scene, this.camera);
				
				// // console.log(this.effect)
				this.controls.update();
				this.renderer.autoClear = false
				this.renderer.clear()
				this.effect.render(this.scene,this.camera);
			}else{
				this.controls.update();
				this.renderer.autoClear = false
				this.renderer.clear()
				this.renderer.outputEncoding = null


				this.renderer.render(this.scene, this.camera);
			}
			
			this.anid = requestAnimationFrame(this.animate);
		},
		fbxLoad(i) {
			let loader = new FBXLoader()
			loader.load(this.model[i].three, (object) => {
				this.flag++;

				object.scale.set(
					this.model[i].scale * 2,
					this.model[i].scale * 2,
					this.model[i].scale * 2
				);
				let index = this.model[i].pic
				const color = new THREE.Color(0xffffff);
				object.children[0].material.map = this.textp[index]
				let material = new THREE.MeshStandardMaterial({
					lightMapIntensity: 1,
					emissiveIntensity: 0,
					metalness: this.model[i].metalness,
					roughness: this.model[i].roughness,
					map: this.textp[index],
					envMap:this.emap
				});
				object.children[0].material = material
				object.children[0].material.color = color



				object.children[0].castShadow = this.model[i].makeShadow ? true : false;
				object.children[0].receiveShadow = this.model[i].Shadow ? true : false;
				object.children[0].geometry.computeBoundingBox();
				object.children[0].material.bumpMap = null
				this.meshList[i] = object.children[0]
				object.children[0].position.x = 0
				object.children[0].position.y = 0
				object.children[0].position.z = 0
				object.children[0].geometry.center()
				let axis = new THREE.Vector3(
					this.model[i].position.x * 2,
					this.model[i].position.y * 2,
					this.model[i].position.z * 2
				);
				object.translateOnAxis(axis, 1);
			
				this.scene.add(object);
				if (this.flag == this.model.length) {

					this.load = false;
				}
			})
		},
		autoLoad(i, loader) {
			loader.load(
				this.model[i].three,
				(geometry) => {
					geometry.computeVertexNormals();
					let mesh;
					
					let index = 0
					if (Array.isArray(this.model[i].pic)) {
						index = this.model[i].pic[0]
					} else {
						index = this.model[i].pic
					}
					let material = new THREE.MeshStandardMaterial({
						lightMapIntensity: 1,
						emissiveIntensity: 0,
						metalness: this.model[i].metalness,
						roughness: this.model[i].roughness,
						map: this.textp[index],
						envMap:this.emap
					});
					geometry.computeBoundingBox();
					if (Array.isArray(this.model[i].pic)) {
						geometry.traverse(function (child) {
							if (child instanceof THREE.Mesh) {
								
								child.material.map = _this.textp[_this.model[i].pic[j]];
								j++
							}
						});
					}
					var centroid = new THREE.Vector3();
					centroid.addVectors(geometry.boundingBox.min, geometry.boundingBox.max);

					centroid.multiplyScalar(0.5);

					mesh = new THREE.Mesh(geometry, material);
					let j = 0
					let _this = this

					mesh.castShadow = this.model[i].makeShadow ? true : false;
					mesh.receiveShadow = this.model[i].Shadow ? true : false;
					centroid.applyMatrix4(mesh.matrixWorld);
					
					mesh.scale.set(
						this.model[i].scale * 2,
						this.model[i].scale * 2,
						this.model[i].scale * 2
					);
					geometry.center()
					// mesh.translateOnAxis(centroid,1)
					let axis = new THREE.Vector3(
						this.model[i].position.x * 2,
						this.model[i].position.y * 2,
						this.model[i].position.z * 2
					);
					mesh.translateOnAxis(axis, 1);
					this.meshList[i] = mesh
					this.scene.add(mesh);
					
					this.flag++;
					
					if (this.flag == this.model.length) {

						this.load = false;
					}
				}

			);
		},
		objLoad(i) {
			this.objLoader.load(this.model[i].three, (object) => {
				this.flag++;
				object.scale.set(
					this.model[i].scale * 2,
					this.model[i].scale * 2,
					this.model[i].scale * 2
				);

				if (this.model[i].pic instanceof Array) {
					let materList = []
					for (let j = 0; j < this.model[i].pic.length; j++) {
						let index = this.model[i].pic[j]
						let material = new THREE.MeshStandardMaterial({
							lightMapIntensity: 1,
							emissiveIntensity: 0,
							metalness: this.model[i].metalness,
							roughness: this.model[i].roughness,
							map: this.textp[index],
							envMap: this.emap
						});
						materList.push(material)
					}
					
					let name = []
					let color = new THREE.Color(0xffffff);
					name.push(object.children[0].material[0].name)
					for (let j = 0; j < object.children[0].material.length; j++) {
						if (name.indexOf(object.children[0].material[j].name) == -1) {
							name.push(object.children[0].material[j].name)
						}
					}
					for (let j = 0; j < object.children[0].material.length; j++) {
						let index = name.indexOf(object.children[0].material[j].name)
						object.children[0].material[j] = materList[index]
						object.children[0].material[j].color = color
					}

				} else {
					let index = this.model[i].pic
					let color = new THREE.Color(0xffffff);
					let material = new THREE.MeshStandardMaterial({
						lightMapIntensity: 1,
						emissiveIntensity: 0,
						metalness: this.model[i].metalness,
						roughness: this.model[i].roughness,
						map: this.textp[index],
						envMap: this.emap
					});
					object.children[0].material = material
					object.children[0].material.color = color
				}


				object.children[0].geometry.center()
				object.children[0].castShadow = this.model[i].makeShadow ? true : false;
				object.children[0].receiveShadow = this.model[i].Shadow ? true : false;
				let axis = new THREE.Vector3(
					this.model[i].position.x * 2,
					this.model[i].position.y * 2,
					this.model[i].position.z * 2
				);
				object.translateOnAxis(axis, 1);
				
				this.meshList[i] = object.children[0]
				this.scene.add(object);
				if (this.flag == this.model.length) {
					
					this.load = false;
					// this.$emit('isloaded')

					
				}
			})
		},
		PicLoad(i, loader) {
			new THREE.TextureLoader().load(this.pic[i], (texture) => {
				// texture.encoding = THREE.sRGBEncoding;
				texture.wrapS = THREE.RepeatWrapping;
				texture.wrapT = THREE.RepeatWrapping
				texture.needsUpdate = true;
				this.textp[i] = texture
				this.falg1++
				
				if (this.falg1 == this.pic.length) {
					
					for (let j = 0; j < this.model.length; j++) {
						if (this.model[j].type == 'fbx') {
							this.fbxLoad(j)
						} else if (this.model[j].type == 'obj') {
							this.objLoad(j)
						} else {
							this.autoLoad(j, loader);
						}



					}
				}
			}

			);

		},
		async getModel() {
			const res = await this.axios.get("/mock.json");
			let id = this.$route.params.id;
			let data = res.data.data;
			
			let work = data.find((item) => {
				return item.id == id;
			});
			this.info = data.find((item) => {
				return item.id == id;
			});
			this.model = work.model;
			this.url = work.url;
			this.pic = work.npic
			this.hdp = work.pic
		},
		modeChoice() {
			if (this.isNormal) {
				this.showDia()
			} else {
				this.norPicc()
			}
		},
		offText() {
			this.more = !this.more;
			

		},
		password() {
			verifyPassword(this.input).then((res) => {
				
				if (res.process == 'success') {
					if (this.hasSHD) {
						this.loadSHD()
					} else {
						this.loadHD()
					}
					this.dialogVisible = !this.dialogVisible
					this.isNormal = false
				} else {
					this.$message.error('密码错误');
				}
			})
		},
		loadHD() {
			this.load = true
			if (!this.loadHDD) {
				this.falg1 = 0
				for (let i = 0; i < this.pic.length; i++) {
					this.HDLoad(i)
				}
			} else {
				this.hdPicc()
			}

		},
		loadSHD() {
			this.load = true
			if (!this.loadSHDD) {
				this.falg2 = 0
				for (let i = 0; i < this.pic.length; i++) {
					this.sphLoad(i)
				}
			} else {
				this.sphPicc()
			}
		},
		resetNormal() {
			this.load = true
			this.norPicc()
		},
		showDia(bool = false) {
			this.hasSHD = bool
			this.dialogVisible = !this.dialogVisible
		},
		showBtn() {
			this.introduce_show = true
			var parentData = this.introduce_show;
			window.parent.postMessage(parentData, '*');
		},
		hideBtn() {
			this.introduce_show = false
			var parentData = this.introduce_show;
			window.parent.postMessage(parentData, '*');
		},
		HDLoad(i) {
			
			new THREE.TextureLoader().load(this.hdp[i], (texture) => {
				texture.encoding = THREE.sRGBEncoding;
				texture.wrapS = THREE.RepeatWrapping;
				texture.wrapT = THREE.RepeatWrapping
				texture.needsUpdate = true;
				this.HDpic[i] = texture
				this.falg1++
				
				if (this.falg1 == this.hdp.length) {
					for (let j = 0; j < this.model.length; j++) {
						let index = parseInt(this.model[j].pic)
						
						this.meshList[j].material.map = this.HDpic[index]
					}
					this.load = false
					this.loadHDD = true
				}
			}, (pro) => {
				
			}

			);

		},
		sphLoad(i) {

			new THREE.TextureLoader().load(this.sph[i], (texture) => {
				texture.encoding = THREE.sRGBEncoding;
				texture.wrapS = THREE.RepeatWrapping;
				texture.wrapT = THREE.RepeatWrapping
				texture.needsUpdate = true;
				this.SPHpic[i] = texture
				this.falg2++
				if (this.falg2 == this.sph.length) {
					for (let j = 0; j < this.model.length; j++) {
						if (this.model[j].pic instanceof Array) {
							for (let k = 0; k < this.model[j].pic.length; k++) {
								let index = parseInt(this.model[j].pic[k])
								this.meshList[j].material[k].map = this.SPHpic[index]
							}
						} else {
							let index = parseInt(this.model[j].pic)

							this.meshList[j].material.map = this.SPHpic[index]
						}

					}
					this.load = false
					this.loadSHDD = true
				}
			}, (pro) => {
				
			}

			);

		},
		norPicc() {
			for (let j = 0; j < this.model.length; j++) {
				let index = parseInt(this.model[j].pic)
				
				this.meshList[j].material.map = this.textp[index]
			}
			this.load = false
		},
		hdPicc() {
			for (let j = 0; j < this.model.length; j++) {
				let index = parseInt(this.model[j].pic)
				
				this.meshList[j].material.map = this.HDpic[index]
			}
			this.load = false
		},
		sphPicc() {
			for (let j = 0; j < this.model.length; j++) {
				if (this.model[j].pic instanceof Array) {
					for (let k = 0; k < this.model[j].pic.length; k++) {
						let index = parseInt(this.model[j].pic[k])
						this.meshList[j].material[k].map = this.SPHpic[index]
					}
				} else {
					let index = parseInt(this.model[j].pic)
					
					this.meshList[j].material.map = this.SPHpic[index]
				}
			}
			this.load = false
		},
		goLastPage() {
			
			if(window.history.length == 1){
				getMiniAppUrl().then((res)=>{	
					let url = res.data.xcx_url
					window.location.href = url
				})
				
				return
			}
			window.history.go(-1)

		},
		changeVr(){
			// this.sceneVR  = new THREE.Scene();
			// this.cameraVR = new THREE.PerspectiveCamera(
			// 	40,
			// 	this.width / this.height,
			// 	1,
			// 	100
			// ); // 设置相机
			// this.cameraVR.position.set(0, 0, 20);
			// // this.fakeCamera = new THREE.Object3D();
			// this.effect = new THREE.VREffect(this.renderer,function () {})
			// this.effect.setSize(this.width, this.height)
			// this.controlsVR = new THREE.VRControls(this.cameraVR);
			// // this.renderer.vr.enabled = true;
			// this.VR = true
			if(this.VR){
				this.camera.position.set(0, 0, 20);
				this.renderer.setSize(this.width, this.height)
				this.VR = false
				return
			}
			if(this.effect){
				this.camera.position.set(0, 0, 40);
				this.VR  = true
				return
			}
			this.effect = new StereoEffect(this.renderer)
			this.effect.setSize(this.width, this.height)
			this.camera.position.set(0, 0, 40);
			this.VR = true
		}
	},
};
</script>


<style scoped>
div {
	margin: 0;
	padding: 0;
	border: 0;
	box-sizing: border-box;

}
.loading{
	width: 100vw;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
}
.loading_img{
	width: 50%;
	object-fit: contain;
}
.container {
	width: 100vw;
	height: 100vh;
	max-width: 100%;  
  	max-height: 100%;  
}

.top {
	position: absolute;
	top: 9vw;
	left: 0;
	width: 100vw;
	padding: 0 7.3vw;
	display: flex;
	justify-content: space-between;
}
.vr_btns{
	position: absolute;
	top: 22vw;
	right: 7.3vw;
}
.vr_btns > div {
	display: flex;
	align-items: center;
	width: 24.2vw;
	height: 7vw;
	justify-content: space-between;
	border-radius: 0.8vw;
	box-shadow: inset 0 0 0 1px #fff;
	color: #fff;
	font-size: 3.7vw;
	box-sizing: border-box;
	padding: 0 2.6vw;
	cursor: pointer;
}
.vr_btns > div:nth-child(1) img{
	width: 5vw;
	height: 3.7vw;
	object-fit: contain;
}

.vr_btns > div:nth-child(2) img{
	width: 3.7vw;
	height: 3.7vw;
	object-fit: contain;
}

.bottom {
	position: absolute;
	bottom: 1vh;
	left: 0;
	width: 100%;
	text-align: center;
	color: #fff;
	font-size: 2.6vw;
}

.bottom .name {
	font-size: 4.8vw;
	margin-bottom: 5.6vw;
}

.left {
	display: flex;
	align-items: center;
	font-size: 4vw;
	color: #fff;
}

.leftSvg {
	width: 3.3vw;
	height: 4vw;
	margin-right: 3.3vw;
}

.right img {
	width: 23vw;
	height: 8.8vw;
	object-fit: contain;
}


@media screen and (orientation: landscape) {
	.top {
		position: absolute;
		top: 2vh;
		left: 0;
		width: 100vw;
		padding: 0 7.3vh;
		display: flex;
		justify-content: space-between;
	}
	.vr_btns{
		position: absolute;
		top: 16vh;
		right: 7.3vh;
	}
	.vr_btns > div {
		display: flex;
		align-items: center;
		width: 24.2vh;
		height: 7vh;
		justify-content: space-between;
		border-radius: 0.8vh;
		box-shadow: inset 0 0 0 1px #fff;
		color: #fff;
		font-size: 3.7vh;
		box-sizing: border-box;
		padding: 0 2.6vh;
		cursor: pointer;
	}
	.vr_btns > div:nth-child(1) img{
		width: 5vh;
		height: 3.7vh;
		object-fit: contain;
	}

	.vr_btns > div:nth-child(2) img{
		width: 3.7vh;
		height: 3.7vh;
		object-fit: contain;
	}

	.bottom {
		position: absolute;
		bottom: 1vh;
		left: 0;
		width: 100%;
		text-align: center;
		color: #fff;
		font-size: 2.6vh;
	}

	.bottom .name {
		font-size: 4.8vh;
		margin-bottom: 1vh;
	}

	.left {
		display: flex;
		align-items: center;
		font-size: 4vh;
		color: #fff;
	}

	.leftSvg {
		width: 3.3vh;
		height: 4vh;
		margin-right: 3.3vh;
	}

	.right img {
		width: 23vh;
		height: 8.8vh;
		object-fit: contain;
	}
}
</style>
